import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatrixDiscountsService } from '../../services/matrix-discounts/matrix-discounts.service';
import { MatrixDiscount } from '../../models/matrix-discount';
import { GungFlowService } from '../../services/gung-flow/gung-flow.service';
import { gungAddRemoveSpinner } from 'gung-common';
import { first } from 'rxjs';

@Component({
    selector: 'lib-matrix-discount-modal',
    templateUrl: './matrix-discount-modal.component.html',
    styleUrls: ['./matrix-discount-modal.component.css'],
    standalone: false
})
export class MatrixDiscountModalComponent implements OnInit {
  form: FormGroup;
  matrixDiscount: MatrixDiscount;
  loading = true;
  saved = false;
  /** Empty option included: a row without a flow applies in all of them. */
  flows: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    protected formBuilder: FormBuilder,
    public matrixDiscountService: MatrixDiscountsService,
    protected gungFlowService: GungFlowService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.gungFlowService
      .getGungFlows()
      .pipe(first())
      .subscribe(flows => (this.flows = flows || []));
  }

  protected initForm() {
    this.form = this.formBuilder.group({
      id: this.formBuilder.control(this.matrixDiscount ? this.matrixDiscount.id : ''),
      customerDiscountGroup: this.formBuilder.control(
        this.matrixDiscount ? this.matrixDiscount.customerDiscountGroup : ''
      ),
      productDiscountGroup: this.formBuilder.control(
        this.matrixDiscount ? this.matrixDiscount.productDiscountGroup : ''
      ),
      flowId: this.formBuilder.control(this.matrixDiscount ? this.matrixDiscount.flowId || '' : ''),
      discountPercent: this.formBuilder.control(this.matrixDiscount ? this.matrixDiscount.discountPercent : ''),
      lowerLimit: this.formBuilder.control(this.matrixDiscount ? this.matrixDiscount.lowerLimit : '')
    });
  }

  onSave({ target }) {
    gungAddRemoveSpinner(target);
    const mDiscount = this.form.getRawValue();
    // The picker's "all flows" option is an empty string. Stored as one it would match neither the
    // flow nor the flowless entry of the lookup's query, so a row saved that way - including any
    // existing row opened to change something else - would stop applying anywhere.
    if (!mDiscount.flowId) {
      mDiscount.flowId = null;
    }
    this.matrixDiscountService.postMatrixDiscount(mDiscount).subscribe({
      next: saved => {
        gungAddRemoveSpinner(target);
        this.saved = true;
        this.activeModal.close(saved);
      },
      error: () => {
        gungAddRemoveSpinner(target);
      }
    });
  }
}
